import { Component, OnInit, Input } from "@angular/core";
import { NavParams } from "@ionic/angular";
import { FirebaseService } from "../firebase/firebase-integration.service";

@Component({
  selector: "app-pop-over",
  templateUrl: "./pop-over.component.html",
  styleUrls: ["./pop-over.component.scss"]
})
export class PopOverComponent implements OnInit {
  @Input() value: any;
  res: unknown[];
  constructor(
    private navParams: NavParams,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {
    this.value = this.navParams.get("value");
    console.log(this.value);
    const number = 4;
    this.firebaseService
      .getHashTagforSearchSupplierList(number)
      .subscribe(res => {
        console.log(res);
        this.res = res;
      });

    
  }

  ionViewDidLoad() {
    document
      .getElementsByTagName("ion-app")
      .item(0)
      .classList.add("disable-scroll");
  }

  ionViewWillLeave() {
    if (
      document
        .getElementsByTagName("ion-app")
        .item(0)
        .classList.contains("disable-scroll")
    ) {
      document
        .getElementsByTagName("ion-app")
        .item(0)
        .classList.remove("disable-scroll");
    }
  }

  
}
